module.exports = __webpack_public_path__ + "static/logos-top-c51ec73d63f50387fe84cb62d359b83f.png";